import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Col, Drawer, Spin } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useEquipmentsMobilization } from "../../../../../hooks/useDataHooks";
import { LoadingOutlined } from "@ant-design/icons";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";


const Name = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const quantityAsPerContract = { xxl: 3, xl: 3, lg: 3, md: 5, sm: 12, xs: 12 };
const quantityMobilized = { xxl: 4, xl: 4, lg: 4, md: 0, sm: 12, xs: 12 };
const statusOfEquipment = { xxl: 4, xl: 4, lg: 4, md: 6, sm: 0, xs: 0 };
const Remarks = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 0, xs: 0 };

const headerLayout = [
  { ...Name, header: "Equipment required" },
  { ...quantityAsPerContract, header: "Quantity required" },
  { ...quantityMobilized, header: "Quantity Mobilized" },
  { ...statusOfEquipment, header: "Mobilization Status" },
  { ...Remarks, header: "Remarks" },
];

const EquipmentMobilization = ({ match }) => {
  const { startDate, endDate } = useReportDateRange();
  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const {
    params: { packageId },
  } = match;
  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name || "";
  const contractId = procuringEntityPackage?.contract?.id;
  const history = useHistory();
  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const { equipments, loading, pagination } = useEquipmentsMobilization(
    contractId,
    startDate,
    endDate,
    currentPage,
    pageSize
  );

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };
  const handleCloseDrawer = () => {
    setVisible(false);
  };

  const packageEquipments = equipments?.map(
    ({
      equipmentName,
      quantityAsPerContract,
      quantityMobilized,
      statusOfEquipment,
      remarks,
    }) => ({
      equipmentName,
      quantityAsPerContract,
      quantityMobilized,
      statusOfEquipment,
      remarks,
    })
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 54,
      }}
      spin
    />
  );

  if (loading) {
    return (
      <Spin
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        indicator={antIcon}
      />
    );
  }

  return (
    <>
      <div style={{ padding: "16px" }}>
        <ActionBar actionButtonProp={{
          title: `${packageName || "==//=="}: Mobilized Equipments`,
          arrActions: [],
          buttons: [],
        }} />
        <div className="prst-table">
        <CustomList
          itemName="Equipment Mobilization"
          showToolbar={false}
          items={packageEquipments || []}
          page={currentPage}
          itemCount={pagination?.total || packageEquipments?.length || 0}
          loading={loading}
          headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id}
              name={item?.equipmentName || "==//=="}
              item={item}
              isPackage={false}
              renderActions={() => false}
              onClick={() => handleRowClick(item)}
              style={{
                backgroundColor:
                  activeItem?.equipmentName === item.equipmentName
                    ? "#f0f0f0"
                    : "transparent",
              }}
            >
              <Col
                {...Name}
                className="contentEllipse"
                data-label="Equipment Required"
                title={item?.equipmentName || "==//=="}
              >
                {item?.equipmentName?.length > 40 ? item?.equipmentName.slice(0, 40) + "..." : item?.equipmentName || "==//=="}
              </Col>
              
              <Col 
                {...quantityAsPerContract} 
                className="contentEllipse"
                data-label="Quantity Required"
              >
                {item?.quantityAsPerContract || "==//=="}
              </Col>
              
              <Col 
                {...quantityMobilized} 
                className="contentEllipse"
                data-label="Quantity Mobilized"
              >
                {item.quantityMobilized || "==//=="}
              </Col>
              
              <Col 
                {...statusOfEquipment} 
                className="contentEllipse"
                data-label="Mobilization Status"
              >
                    {item.statusOfEquipment || "==//=="}
              </Col>
              
              <Col 
                {...Remarks} 
                className="contentEllipse"
                data-label="Remarks"
              >
                {item.remarks?.length > 40 ? item.remarks.slice(0, 40) + "..." : item.remarks || "==//=="}
              </Col>
              
              <button 
                className="view-card-details" 
                onClick={() => handleRowClick(item)}
              >
                View Details
              </button>
            </ListItem>
          )}
        />
        </div>
        
        <CustomPagination 
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
        <Drawer
          title="Equipment Details"
          placement="right"
          onClose={handleCloseDrawer}
          visible={visible}
          width={720}
        >
          {activeItem && (
            <div>
              {/* <h3>{activeItem.equipmentName}</h3>
               */}
              <p>
                <strong>Equipment required as per contract:</strong>{" "}
                {activeItem.equipmentName || "==//=="}
              </p>
              <p>
                <strong>Quantity as per contract:</strong>{" "}
                {activeItem.quantityAsPerContract || "==//=="}
              </p>
              <p>
                <strong>Quantity Mobilized:</strong>{" "}
                {activeItem.quantityMobilized || "==//=="}
              </p>
              <p>
                <strong>Mobilization Status:</strong>{" "}
                  {activeItem.statusOfEquipment || "==//=="}
              </p>
              <p>
                <strong>Remarks:</strong> {activeItem.remarks || "==//=="}
              </p>
            </div>
          )}
        </Drawer>
      </div>
    </>
  );
};

export default EquipmentMobilization;
